import { useMutation } from '@apollo/client';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import GetUpliftIndexesQuery from '@/graphql/contracts/getUpliftIndexes.query.gql';
import AddUpliftIndexMutation from '@/graphql/contracts/addUpliftIndex.mutation.gql';
import {
  AddUpliftIndex,
  AddUpliftIndexVariables
} from '@/graphql/contracts/_generated_/addUpliftIndex.mutation';

export function useAddUpliftIndex(regionName?: string) {
  return useMutation<AddUpliftIndex, AddUpliftIndexVariables>(AddUpliftIndexMutation, {
    client: apolloClientContracts,
    refetchQueries: () => [{
      query: GetUpliftIndexesQuery,
      variables: {
        region: regionName,
        includeRates: true,
      },
    }],
  });
}
